import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const InquiryList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const fetchInquiries = () => {
    setLoading(true);
    axios
      .get("inquiries/")
      .then((res) => setRows(res.data))
      .catch((e) => {
        console.error(e);
        alert("Could not load inquiries");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this inquiry?")) {
      try {
        await axios.delete(`inquiries/${id}`);
        fetchInquiries(); // refresh list
      } catch (err) {
        console.error("Failed to delete inquiry:", err);
        alert("Failed to delete inquiry");
      }
    }
  };

  if (loading) return <p>Loading inquiries…</p>;

  const rowClass = (r) =>
    r.priority === "Urgent" ? "table-danger" : "";

  return (
    <div className="container mt-4">
      <h4>All Inquiries</h4>
      <div className="table-responsive">
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Branch</th>
              <th>Staff</th>
              <th>Customer</th>
              <th>Type</th>
              <th>Subject</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={10} className="text-center">
                  No inquiries yet
                </td>
              </tr>
            )}
            {rows.map((r) => (
              <tr key={r.id} className={rowClass(r)}>
                <td>{r.id}</td>
                <td>{r.branch_name}</td>
                <td>{r.staff_name}</td>
                <td>{r.customer_name || "-"}</td>
                <td>{r.inquiry_type}</td>
                <td>{r.subject}</td>
                <td>{r.priority}</td>
                <td>{r.status}</td>
                <td>{new Date(r.created_at).toLocaleString()}</td>
                <td>
                  <div className="d-flex gap-2">
                    <button 
                      className="btn btn-sm btn-info text-white" 
                      onClick={() => navigate(`/dashboard/inquiries/${r.id}`)}
                      title="View"
                    >
                      <i className="bi bi-eye"></i> View
                    </button>
                    <button 
                      className="btn btn-sm btn-primary" 
                      onClick={() => navigate(`/dashboard/inquiries/edit/${r.id}`)}
                      title="Edit"
                    >
                      <i className="bi bi-pencil"></i> Edit
                    </button>
                    <button 
                      className="btn btn-sm btn-danger" 
                      onClick={() => handleDelete(r.id)}
                      title="Delete"
                    >
                      <i className="bi bi-trash"></i> Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InquiryList;
